export default __webpack_public_path__ + "static/media/rice.8f67c6f9.jpeg";